import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import request from '~/apis/request'
import { loadingStates } from '~/config/constant'
import STORAGE_KEYS from '~/constants/localStorage'
import { getInfoRestaurant } from '~/utils'

export const servingRequest = createAsyncThunk('callStaff/servingRequest', async () => {
  const { restaurantId, tableId } = getInfoRestaurant()
  const response = await request().post(`/restaurants/${restaurantId}/tables/${tableId}/requests`, {
    requests: [
      {
        kind: 'call_staff',
      },
    ],
    number_of_people: Number(localStorage.getItem(STORAGE_KEYS.NUMBER_OF_PEOPLE)),
  })

  return response.data
})

const callStaffSlice = createSlice({
  name: 'callStaff',
  initialState: {
    error: null,
    loading: loadingStates.idle,
    data: {},
    servingSessionID: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(servingRequest.pending, (state) => {
        state.loading = loadingStates.pending
      })
      .addCase(servingRequest.fulfilled, (state, action) => {
        state.loading = loadingStates.success
        const { serving_session_id } = action.payload
        // Trường hợp separate order
        if (serving_session_id) {
          state.servingSessionID = serving_session_id
          localStorage.setItem(STORAGE_KEYS.SERVING_SESSION_ID, serving_session_id)
        }

        state.data = action.payload.data
      })
      .addCase(servingRequest.rejected, (state, action) => {
        state.loading = loadingStates.error
        state.error = action.error.code
      })
  },
})

export const infoCallStaffSelector = (state) => state.callStaff

export default callStaffSlice.reducer
